import axios, { AxiosResponse } from 'axios';

import { PropertyDto } from '@tallo/property';

import { SaveSyndicationDto } from '../dtos/save-syndication.dto.interface';
import { SyndicationPlatformsResponseDto } from '../dtos/syndication-platforms-response.dto.interface';
import { ToggleAutoRefreshDto } from '../dtos/toggle-auto-refresh.dto.interface';

class PropertyListingService {
  async listProperty(propertyId: string, syndicationData?: SaveSyndicationDto): Promise<AxiosResponse<PropertyDto>> {
    return await axios.put(`property-listing/publish/${propertyId}`, syndicationData);
  }

  async pauseProperty(propertyId: string): Promise<AxiosResponse<PropertyDto>> {
    return await axios.put(`property-listing/pause/${propertyId}`);
  }

  async markAsRentedOut(propertyId: string): Promise<AxiosResponse<PropertyDto>> {
    return await axios.put(`property-listing/complete/${propertyId}`);
  }

  async toggleAutoRefresh(
    propertyId: string,
    toggleData: ToggleAutoRefreshDto,
  ): Promise<AxiosResponse<{ success: boolean; autoRefresh: boolean }>> {
    return await axios.patch(`property-listing/${propertyId}/auto-refresh`, toggleData);
  }

  async getSyndicationPlatforms(propertyId: string): Promise<AxiosResponse<SyndicationPlatformsResponseDto>> {
    return await axios.get(`property-listing/syndication-platforms/${propertyId}`);
  }

  async updateSyndication(
    propertyId: string,
    syndicationDto: SaveSyndicationDto,
  ): Promise<AxiosResponse<{ success: boolean; platforms: string[] }>> {
    return await axios.patch(`property-listing/syndication/${propertyId}`, syndicationDto);
  }
}

export default new PropertyListingService();
